"use client";
import { useMapContext } from "@components/sections/mapSection/MapProvider";
import { Accordion } from "@components/ui/accordion";
import { Button } from "@components/ui/button";
import { getUniqueQueryKeys } from "@lib/utils/getUniqueQueryKeys";
import { MapFilters } from "@lib/utils/types/filters";
import { useTranslations } from "next-intl";

import { useMapForm } from "./mapForm.hooks";
import { MapFormFieldMapper } from "./MapFormFieldMapper";

interface IMapForm {
  filters: MapFilters;
  label?: string;
  results?: number;
}

export default function MapForm({ filters, results }: IMapForm) {
  const [query, onSelect, toggleAll, clear] = useMapForm({
    allowedQueryKeys: getUniqueQueryKeys(filters),
  });
  const { clearMarkerPopup, setFilter } = useMapContext();
  const t = useTranslations("Filters");

  return (
    <form className="h-full flex-1 overflow-y-scroll">
      <span className="my-4 block text-2xl font-bold">{t("Title")}</span>
      <Accordion type="multiple" className="w-full">
        {filters.entries.map(filterGroup => (
          <MapFormFieldMapper
            key={filterGroup.id}
            filter={filterGroup}
            onSelect={onSelect}
            toggleAll={toggleAll}
            query={query}
          />
        ))}
      </Accordion>
      <div className="mt-auto flex h-20 w-full flex-row flex-wrap items-center justify-between border-t border-t-[#AAAAAA]">
        <Button
          onClick={e => {
            e.preventDefault();
            clearMarkerPopup();
            setFilter(null);
            clear();
          }}
          size="sm"
          variant="link"
          className="p-0"
        >
          {t("Actions.Reset")}
        </Button>
        {filters && results && (
          <div>
            {t("Actions.Visit")} {results} {t("Actions.Results")}
          </div>
        )}
      </div>
    </form>
  );
}
